<template>
    <div>
        <div class="order-tmp-caption" style="font-size: 15px;color: #1a1a1a;font-weight: 600;text-align: center;padding: 15px 0;">{{servcWorkAddItemResult.name}}</div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;font-size: 12px;">
            <tbody class="body">
            <tr class="row" align="left" v-for="(tableUpItem, index) in servcWorkAddItemResult.tableUpItemList">
                <td style="border:none;vertical-align: middle;padding: 10px 4px;">{{tableUpItem.contentFist}}:</td>
                <td style="border:none;vertical-align: middle;padding: 10px 4px;">{{tableUpItem.remarkFist}}</td>
                <td style="border:none;vertical-align: middle;padding: 10px 4px;">{{tableUpItem.contentTwo}}</td>
                <td style="border:none;vertical-align: middle;padding: 10px 4px;">{{tableUpItem.remarkTwo}}</td>
            </tr>
            </tbody>
        </table>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;color: #666;font-size: 12px;">
            <tbody class="body">
            <tr class="row" align="left" v-for="tableItem in servcWorkAddItemResult.tableItemList">
                <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">{{tableItem.content}}</td>
                <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">{{tableItem.remark}}</td>
            </tr>
            </tbody>
        </table>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;font-size: 12px;">
            <tbody class="body">
            <tr class="row" align="left" v-for="(tableDwItem, index) in servcWorkAddItemResult.tableDwItemList">
                <td style="border: none;vertical-align: middle;padding: 10px 4px;">{{tableDwItem.contentFist}}:</td>
                <td style="border:none;vertical-align: middle;padding: 10px 4px;">{{tableDwItem.remarkFist}}</td>
                <td style="border: none;vertical-align: middle;padding: 10px 4px;">{{tableDwItem.contentTwo}}</td>
                <td style="border:none;vertical-align: middle;padding: 10px 4px;">{{tableDwItem.remarkTwo}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    //
    import servcDelivApi from '../../api/servcDeliv'
    //
    export default {
        name: 'swb-servc-work-add-item-list',
        desc: '工单补充项目',
        props: ["id"],
        data: function () {
            return {
                servcWorkAddItemResult: {},
                servcWorkVoucher: {},
            }
        },
        created: function () {
            this.getServcWorkVoucherById();
        },
        methods: {
            getServcWorkVoucherById: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                servcDelivApi.getServcWorkVoucherDetail(postData, function (result) {
                    if (result.type == "info") {
                        let servcWorkVoucher = result.data;
                        self.getServcWorkAddItemList(servcWorkVoucher);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getServcWorkAddItemList: function (servcWorkVoucher) {
                let self = this;
                let postData = {};
                postData.voucherId = self.id;
                servcDelivApi.getServcWorkAddItemList(postData, function (result) {
                    if (result.type == "info") {
                        let servcWorkAddItemResult = getServcWorkAddItemResult(null, result.data, servcWorkVoucher, true);
                        let tableUpItemList = servcWorkAddItemResult.tableUpItemList;
                        let upItemList = [];
                        for (let i = 0; i < tableUpItemList.length; i = i + 2) {
                            let upItem = {};
                            let tableUpItem = tableUpItemList[i];
                            upItem.contentFist = tableUpItem.content;
                            upItem.remarkFist = tableUpItem.remark;
                            if (i + 1 < tableUpItemList.length) {
                                let tableItem2 = tableUpItemList[i + 1];
                                upItem.contentTwo = tableItem2.content;
                                upItem.remarkTwo = tableItem2.remark;
                            }
                            upItemList.push(upItem);
                        }
                        servcWorkAddItemResult.tableUpItemList = upItemList;
                        //
                        let tableDwItemList = servcWorkAddItemResult.tableDwItemList;
                        let dwItemList = [];
                        for (let i = 0; i < tableDwItemList.length; i = i + 2) {
                            let dwItem = {};
                            let tableDwItem = tableDwItemList[i];
                            let tableDwItem2 = tableDwItemList[i + 1];
                            dwItem.contentFist = tableDwItem.content;
                            dwItem.remarkFist = tableDwItem.remark;
                            if (i + 1 < tableDwItemList.length) {
                                dwItem.contentTwo = tableDwItem2.content;
                                dwItem.remarkTwo = tableDwItem2.remark;
                                dwItemList.push(dwItem);
                            }
                        }
                        servcWorkAddItemResult.tableDwItemList = dwItemList;
                        self.servcWorkAddItemResult = servcWorkAddItemResult;
                    }
                })
            },
            getHtml: function () {
                return this.$el.outerHTML;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkAddItem.vue